export default {
    data() {
        return {
            Countly: null
        }
    }
}